<template>
  <div>
    <a-row type="flex" class="row_item">
      <a-col :span="2" style="padding-top: 15px">
        <span v-if="index >= 0">{{ index + 1 }}、
          <a @click="to(item)">额度占用申请</a>
        </span>
        <span v-else>额度占用申请</span>
      </a-col>
      <a-col :span="22">
        <div :title="item.name">
          <div style="padding-left: 16px;">
            <span class="desc">业务号：{{ item.business_no }}</span>
            <span class="desc" v-if="item.issuing_bank">开征银行：{{ item.issuing_bank }}</span>
            <span class="desc" v-if="item.bank_services_type">业务类型：{{ dictionaries.bank_services_types[item.bank_services_type] }}</span>
            <span class="desc" v-if="item.business_amount">业务金额：{{ item.business_amount | numberFormat }} {{ dictionaries.currency[item.business_currency] }}</span>
            <span class="desc" v-if="item.business_amount_more_less_clause">金额溢短装：{{ item.business_amount_more_less_clause }}</span>
            <span class="desc" v-if="item.weight">重量：{{ item.weight | numberFormat }} {{ dictionaries.unit[item.weight_unit] }}</span>
            <span class="desc" v-if="item.重量溢短装">重量溢短装：{{ item.重量溢短装 }}</span>
            <span class="desc" v-if="item.margin_ratio">保证金比例：{{ item.margin_ratio }} %</span>
            <span class="desc" v-if="item.planned_exposure_amount">拟占用敞口金额：{{ item.planned_exposure_amount }} {{ dictionaries.currency[item.planned_exposure_currency] }}</span>
            <span class="desc" v-if="item.letter_credit_type">信用证类型：{{ dictionaries.letter_credit_types[item.letter_credit_type] || '' }}</span>
            <span class="desc" v-if="item.usance_days">远期天数：{{ item.usance_days }}</span>
            <span class="desc" v-if="item.margin_source">保证金来源：{{ dictionaries.margin_resources[item.margin_source] || '' }}</span>
            <span class="desc" v-if="item.lc_date">开征日期：{{ item.lc_date }}</span>
            <span class="desc" v-if="item.advising_bank">通知行：{{ item.advising_bank }}</span>
            <span class="desc">创建时间：{{ item.create_time | dayjs }}</span>
            <span class="desc">已开启审批：
              <a-popconfirm
                title="确定开启审批吗?"
                :disabled="item.is_approval_needed"
                @confirm="() => approvalNeeded(item, 'trade_lc_application', item.status === 3)">
                <a-switch checked-children="是" un-checked-children="否" :checked="item.is_approval_needed" :disabled="item.is_approval_needed"/>
              </a-popconfirm>
            </span>
            <span class="desc" v-if="item.is_approval_needed">审批状态：<span :class="statusText[item.status < 0 ? 0 : item.status][0]">{{ item.is_approval_needed ? (dictionaries.approval_result[item.status] ? dictionaries.approval_result[item.status] : '无') : un_approval_needed_text }}</span></span>

          </div>
          <div style="padding-left: 16px;" v-if="false">
            <span class="desc">操作:</span>
            <span class="ope">
              <span @click="handleEditRecord(item, 'settlement')">编辑</span>
              <a-popconfirm
                title="确定删除吗?"
                @confirm="() => handleDelete(item, 'settlement')">
                <span>删除</span>
              </a-popconfirm>
              <a-popconfirm
                v-if="item.is_approval_needed && item.status === 3"
                title="确定重启审批?"
                @confirm="() => approvalNeeded(item, 'trade_settlement', true)">
                <span>重启审批</span>
              </a-popconfirm>
            </span>
          </div>
          <div v-if="false">
            <a-collapse :bordered="false">
              <template #expandIcon="props">
                <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
              </template>
              <a-collapse-panel key="2" header="附件" :style="customStyle">
                <a v-for="(attachment) in item.attachment" :key="attachment.id" :href="attachment.url" target="_blank" class="desc"><a-icon type="file" theme="filled" /> {{ attachment.name }}</a>
              </a-collapse-panel>
            </a-collapse>
          </div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { Dictionaries } from '@/common/AllConstant'

export default {
  name: 'LcApplicationInfo',
  props: {
    item: {
      type: Object,
      default: () => {
        return null
      }
    },
    index: {
      type: Number,
      default: 0
    },
    edit: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      customStyle: 'background: #f7f7f7;border-radius: 4px;margin-bottom: 1px;border: 0;overflow: hidden',
      dictionaries: Dictionaries,
      un_approval_needed_text: '未开启审批',
      statusText: {
        0: ['none', '无'],
        1: ['waiting', '审批中'],
        2: ['pass', '通过'],
        3: ['un_pass', '驳回']
      }
    }
  },
  methods: {
    to (item) {
      const path = '/trade/lc_application'
      this.$router.push({ path: path, query: { id: item.id } })
    },
    handleArchived (item, type) {
      this.$emit('handleArchived', item, type)
    },
    handleEditRecord (item, type) {
      this.$emit('handleEditRecord', item, type)
    },
    handleDelete (item, type) {
      this.$emit('handleDelete', item, type)
    },
    approvalNeeded (item, type, approval_again) {
      this.$emit('approvalNeeded', item, type, approval_again)
    }
  }
}
</script>

<style scoped>
.desc {
  padding-right: 20px;
  height: 40px;
  line-height: 40px;
  display: inline-block;
}
.row_item {
  border-bottom: 1px solid #eeeeee;
  padding: 10px 20px;
  background-color: #f7f7f7;
  margin-top: 5px;
  border-radius: 10px;
}
.ope>span:hover {
  color: #2a99ff;
  cursor: pointer;
}
.ope>span:first-child {
  padding-left: 0px;
  height: 40px;
  line-height: 40px;
}
.ope>span:not(:first-child) {
  padding-left: 20px;
  height: 40px;
  line-height: 40px;
}
.content {
  /*color: #00A0E9;*/
  /*font-weight: bolder*/
}
.none {
  color: #333333;
}
.waiting {
  color: yellowgreen;
}
.pass {
  color: green;
}
.un_pass {
  color: red;
}
.space {
  margin-top: 5px;
  overflow-x: auto;
}
.important-content {
  font-weight: bold;
}
</style>
